// src/pages/Login.tsx
import React, { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import api from "../api/api";
import axios from 'axios';

import { MediaQuery } from 'react-responsive';
import * as LoginStyle from "../styles/Login.style";

import LoginLogoTabletIcon from '../imgs/ic_REK_login_tablet.svg';
import LoginSymbolTabletIcon from '../imgs/ic_symbol_login_tablet.svg';
import LoginText1TabletIcon from '../imgs/ic_login_text1_tablet.svg';
import LoginText2TabletIcon from '../imgs/ic_login_text2_tablet.svg';


//const SOCKET_URL = 'http://172.16.20.112:3000';
//const SOCKET_URL = 'https://rek-hybrid.co.kr'; // 실제 서버 주소
const SOCKET_URL = 'https://rek-hybrid.co.kr';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      //await login(id, pw);
      //const res = await axios.post(SOCKET_URL+"/auth/login", { id, pw });
      const res = await axios.post(SOCKET_URL+"/api/auth/login", { id, pw });
      login(res.data.accessToken, res.data.refreshToken, res.data.user); // AuthProvider에 전달
      //console.log("로그인 응답:", res.data);
      //localStorage.setItem("accessToken", res.data.accessToken);
      //localStorage.setItem("refreshToken", res.data.refreshToken);
      //localStorage.setItem("user", JSON.stringify(res.data.user));
      navigate('/'); // 로그인 성공 시 홈으로 이동
    } catch (e: any) {
      setErr(e?.response?.data?.message || '로그인 실패');
      //alert(e?.response?.data?.message || '로그인 실패');
    }
  };

// 🎨 스타일 상수 정의
  const COLORS = {
    primary: '#007bff', // 파란색 (버튼 색상)
    background: '#f8f9fa', // 연한 배경색
    cardBg: '#ffffff', // 카드 배경색
    inputBorder: '#ced4da', // 입력 필드 테두리
    error: '#dc3545', // 에러 텍스트 색상
  };
  
  // 폼 컨테이너 스타일 (카드 디자인)
  const containerStyleM = {
    maxWidth: '80%',
    margin: '80px auto 0', // 상단 여백 유지 및 중앙 정렬
    padding: '40px',
    backgroundColor: COLORS.cardBg,
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // 은은한 그림자
    // textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '80px auto 0', // 상단 여백 유지 및 중앙 정렬
    padding: '40px',
    backgroundColor: COLORS.cardBg,
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // 은은한 그림자
    // textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  };

  // 입력 필드 스타일
  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    margin: '10px 0',
    border: `1px solid ${COLORS.inputBorder}`,
    borderRadius: '8px',
    // boxSizing: 'border-box',
    fontSize: '16px',
  };

  // 버튼 스타일
  const buttonStyle = {
    width: '100%',
    padding: '14px',
    marginTop: '25px',
    backgroundColor: COLORS.primary,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  };

  return (
    <>
    <MediaQuery maxWidth={767}>

      <LoginStyle.BackgroundArea>
        <LoginStyle.LogoArea>
          <LoginStyle.LogoFrame>

            <LoginStyle.LogoLeft
              $imgUrl={LoginSymbolTabletIcon}
              />
              <LoginStyle.LogosubFrame>
                <LoginStyle.LogoRight
                  $imgUrl={LoginLogoTabletIcon}
                  />
                <LoginStyle.LogoTextsWrapper>
                  <LoginStyle.LogoText1
                    $imgUrl={LoginText1TabletIcon}
                  />
                  <LoginStyle.LogoText2
                    $imgUrl={LoginText2TabletIcon}
                  />            
                </LoginStyle.LogoTextsWrapper>
            </LoginStyle.LogosubFrame>

          </LoginStyle.LogoFrame>
        </LoginStyle.LogoArea>

        {/* <LoginStyle.LoginArea> */}

          <div style={containerStyleM}>
            
            <form onSubmit={onSubmit}>
              
              {/* 🌟 깔끔한 입력 필드 (Label 제거 및 Placeholder 활용) */}
              <div>
                <input 
                  type="text"
                  value={id} 
                  onChange={(e) => setId(e.target.value)} 
                  placeholder="아이디를 입력하세요" // Placeholder로 안내
                  style={inputStyle}
                  required
                />
              </div>
              
              <div>
                <input 
                  type="password" 
                  value={pw} 
                  onChange={(e) => setPw(e.target.value)} 
                  placeholder="비밀번호를 입력하세요" // Placeholder로 안내
                  style={inputStyle}
                  required
                />
              </div>
              
              <button type="submit" style={buttonStyle}>
                로그인
              </button>
              
              {err && (
                <div style={{ color: COLORS.error, marginTop: '15px', fontSize: '14px' }}>
                  {err}
                </div>
              )}
              
            </form>
            
          </div>

        {/* </LoginStyle.LoginArea> */}

      </LoginStyle.BackgroundArea>

    </MediaQuery>


{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* **************************** 태블릿, 데스트톱 UI ****************************** */}

    <MediaQuery minWidth={768}>

      <LoginStyle.BackgroundArea>
        <LoginStyle.LogoArea>
          <LoginStyle.LogoFrame>

            <LoginStyle.LogoLeft
              $imgUrl={LoginSymbolTabletIcon}
              />
              <LoginStyle.LogosubFrame>
                <LoginStyle.LogoRight
                  $imgUrl={LoginLogoTabletIcon}
                  />
                <LoginStyle.LogoTextsWrapper>
                  <LoginStyle.LogoText1
                    $imgUrl={LoginText1TabletIcon}
                  />
                  <LoginStyle.LogoText2
                    $imgUrl={LoginText2TabletIcon}
                  />            
                </LoginStyle.LogoTextsWrapper>
            </LoginStyle.LogosubFrame>

          </LoginStyle.LogoFrame>
        </LoginStyle.LogoArea>
        
        <LoginStyle.LoginArea>
          <div style={containerStyle}>
            
            {/* 🌟 트렌디한 제목 디자인 */}
            <center><h1 style={{ 
              fontSize: '28px', 
              fontWeight: '800', 
              marginBottom: '30px', 
              color: '#343a40' // 어두운 색상
            }}>
              Hybrid<br></br>StreetLamp<br></br>Manager
            </h1></center>
            
            <form onSubmit={onSubmit}>
              
              {/* 🌟 깔끔한 입력 필드 (Label 제거 및 Placeholder 활용) */}
              <div>
                <input 
                  type="text"
                  value={id} 
                  onChange={(e) => setId(e.target.value)} 
                  placeholder="아이디를 입력하세요" // Placeholder로 안내
                  style={inputStyle}
                  required
                />
              </div>
              
              <div>
                <input 
                  type="password" 
                  value={pw} 
                  onChange={(e) => setPw(e.target.value)} 
                  placeholder="비밀번호를 입력하세요" // Placeholder로 안내
                  style={inputStyle}
                  required
                />
              </div>
              
              <button type="submit" style={buttonStyle}>
                로그인
              </button>
              
              {err && (
                <div style={{ color: COLORS.error, marginTop: '15px', fontSize: '14px' }}>
                  {err}
                </div>
              )}
              
            </form>
            
          </div>
        </LoginStyle.LoginArea>
      </LoginStyle.BackgroundArea>

    </MediaQuery>
    </>

  );
};

export default Login;
